export default {
  id: "datetime",
  name: "Datetime",
  settings: {
    useDateTimeTimezone: false
  }
};
